import { Link, useNavigate } from "react-router-dom";
import Pagination from "../../Components/Pagination";
import { MyContext } from "../../Components/Context";
import { useContext, useState, useEffect } from "react";
import api from "../../api/api";
import SearchField from "../../Components/Forms/SearchField";
import Loader from "../../Components/Loader";


export default function Plaintes() {
    const navigate = useNavigate();
    const { actifItem, setActifItem } = useContext(MyContext);
    const [plaintes, setPlaintes] = useState([]);
    const [currentPage, setCurrentPage] = useState(1); 
    const [totalPages, setTotalPages] = useState(1);   
    const [search, setSearch] = useState("");          
    const [loading, setLoading] = useState(true); 
         

    useEffect(() => {
        const getData = async () => {
            setLoading(true); 
            try {
                const response = await api.get('plaintes', {
                    params: {
                        page: currentPage,
                        limit: 10,
                        search: search 
                    }
                });

                setPlaintes(response.data.rows);
                setTotalPages(response.data.totalPages); 
                setActifItem('Plaintes')
                
            } catch (error) {
                console.error('Erreur lors de la récupération des plaintes:', error);
            }
            setLoading(false); 
        };
        getData();
    }, [currentPage, search]); 
    return (
        <div className="px-4 md:px-8">
            <div className="max-w-lg">
                <div className="flex items-center justify-between">
                    <div>
                        <h3 className="text-xl font-bold text-gray-800 sm:text-2xl dark:text-gray-200">
                            Plaintes
                        </h3>
                        
                    </div>
                    <div className="mt-3 md:mt-0">
                        {/* Optionnel : Bouton pour ajouter une nouvelle plainte */}
                        {/* 
                        <button
                            className="inline-block px-4 py-2 font-medium text-white duration-150 bg-indigo-600 rounded-lg hover:bg-indigo-500 active:bg-indigo-700 md:text-sm"
                            onClick={() => { navigate('/plaintes/creation') }}
                        >
                            Ajouter
                        </button>
                        */}
                    </div>
                </div>
                
                <SearchField 
                    onSearch={(term) => {
                        setSearch(term);
                        setCurrentPage(1); 
                    }} 
                    placeholder="Rechercher des plaintes..."
                />
            </div>
            <div className="mt-12 overflow-x-auto shadow-sm">
                {loading ? (
                    <Loader />
                ) : plaintes.length === 0 ? (
                    <div className="flex items-center justify-center h-64 text-center text-gray-600">
                        <p className="text-xl font-medium dark:text-gray-200">Aucune plainte trouvée.</p>
                    </div>
                ) : (
                    <table className="w-full text-sm text-left table-auto">
                        <thead className="font-medium text-gray-600 bg-gray-200 border-b dark:text-gray-200 dark:bg-gray-800 dark:border-gray-600">
                            <tr>
                                <th className="px-6 py-3">Id</th>
                                <th className="px-6 py-3">Plaignant</th>
                                <th className="px-6 py-3">Titre</th>
                                <th className="px-6 py-3">Contenu</th>
                                <th className="px-6 py-3">Date</th>
                                <th className="px-6 py-3">Type</th>
                                <th className="px-6 py-3">Statut</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 divide-y">
                            {plaintes.map((item, idx) => (
                                <tr 
                                    key={item.id} 
                                    className="w-full text-left transition duration-300 rounded cursor-pointer hover:dark:bg-gray-200 dark:text-gray-200 dark:bg-gray-800 dark:border-gray-600 hover:dark:text-gray-700"
                                    onClick={() => {
                                        navigate(`/plainte/details/${item.id}`);
                                        setActifItem('Plaintes');
                                    }}
                                >
                                    <td className="flex items-center px-6 py-3 gap-x-3 whitespace-nowrap">
                                        <div>
                                            <span className="block text-sm font-medium animate-fade duration-400">{item.id}</span>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        {item.client.lastname} {item.client.firstname}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">{item.title}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{item.contenu}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        {new Date(item.createdAt).toLocaleDateString()}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">{item.type}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <span className={`${
                                            item.state === 'RESOLVED' ? 'bg-green-300 font-bold text-sm text-green-800 rounded-xl text-center px-4 py-1' :
                                            item.state === 'PROCESSING' ? 'bg-purple-300 font-bold text-sm text-purple-800 rounded-xl text-center px-4 py-1' :
                                            item.state === 'ABORDTED' ? 'bg-gray-300 font-bold text-sm text-gray-800 rounded-xl text-center px-4 py-1' :
                                            'bg-blue-300 font-bold text-sm text-blue-800 rounded-xl text-center px-4 py-1'
                                        }`}>
                                            {item.state}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
            
            
            {(totalPages >= 1 || plaintes.length > 0) && (
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={(page) => setCurrentPage(page)}
                />
            )}
        </div>
    );
}
